import { useState } from 'react';

import { Disc3 } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import Error from '@/components/common/Error';

import { usePutChangePassword } from '@/data/user';
import { passwordFormSchema } from '@/app/user/_validators';

const ChangePasswordForm = ({ onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');
  const putChangePassword = usePutChangePassword();

  const form = useForm({
    resolver: zodResolver(passwordFormSchema),
    defaultValues: {
      password: '',
      newPassword: '',
      confirmPassword: ''
    }
  });

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      setApiError('');
      const payload = {
        password: values.password,
        newPassword: values.newPassword
      };
      await putChangePassword(payload);
      onSuccess();
    } catch (error) {
      setApiError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Existing Password</FormLabel>
              <FormControl>
                <Input type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="newPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>New Password</FormLabel>
              <FormControl>
                <Input type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="confirmPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Confirm New Password</FormLabel>
              <FormControl>
                <Input type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {apiError && <Error error={apiError} />}
        <div className="flex justify-end">
          <Button type="submit" disabled={submitting}>
            {submitting && <Disc3 className="animate-spin" />}
            Change Password
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default ChangePasswordForm;
